// extracted by mini-css-extract-plugin
export var dropdownContainer = "_m7-0";
export var leftAlign = "_m7-4";
export var listItem = "_m7-2";
export var listItemWrapper = "_m7-1";
export var operationText = "_m7-3";